// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import ProvinceTable from "../../DataTables/MasterData/Province/ProvinceTable";

// Modals
import CreateProvinceModal from "../../UiKits/Modal/MasterData/Province/CreateProvince";

const ProvinceContainer = () => {
  return (
    <>
      <Breadcrumbs
        mainTitle="Province"
        parent="Master Data / Address & Location"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Province Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage province options used throughout the HRIS for employee
                  and applicant personal information.
                </P>
                <CreateProvinceModal />
                <ProvinceTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProvinceContainer;
